import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8.576 5.576a.6.6 0 0 1 .848 0l6 6a.6.6 0 0 1 0 .848l-6 6a.6.6 0 0 1-.848-.848L14.15 12 8.576 6.424a.6.6 0 0 1 0-.848Z"
      clip-rule="evenodd"
    />
  </svg>
`;
